import { createIdentifier } from '@wix/thunderbolt-ioc'
import type { IDomStore, ISvgFetcher, ISvgDomStoreLoader } from './types'

export const name = 'domStore' as const

export const DomStoreSymbol = createIdentifier<IDomStore>(Symbol('DomStore'))
export const SvgFetcherSymbol = createIdentifier<ISvgFetcher>(Symbol('SvgFetcher'))
export const SvgDomStoreLoaderSymbol = createIdentifier<ISvgDomStoreLoader>(Symbol('SvgDomStoreLoader'))
